import { LAST_DEPARTMENT_ID } from 'api/http';
import { DataSelect } from 'components/v2/input/AutoCompleteInput';
import { useAuth } from 'modules/auth/hooks';
import { useState } from 'react';

export const useCurrentBranch = () => {
  const { user, isError, userIsLoading, refetch } = useAuth();
  const currentSelectedBranch =
    user?.branches?.find(branch => branch.id === localStorage.getItem(LAST_DEPARTMENT_ID)) ?? user?.branches?.[0];
  const [branches, setBranches] = useState(currentSelectedBranch?.id);

  const handleChange = (option: DataSelect) => {
    localStorage.setItem(LAST_DEPARTMENT_ID, option.value);
    setBranches(option.value);
  };

  return {
    actions: {
      handleChange,
      refetch,
    },
    clientStates: {
      branches,
      currentSelectedBranch,
    },
    apiStates: {
      isError,
      userIsLoading,
      userName: user?.firstName,
    },
  };
};
